
// 文本多行展开收起组件
Vue.component("auto-text-clamp", {
  props: {
    text: {
      type: String,
      default: "",
    },
    max_lines: {
      type: Number,
      default: 3,
    },
    line_height: {
      type: Number,
      default: 1.5,
    }
  },
  data() {
    return {
      expanded: false,
      showSlotNode: false,
      calcText: '',
      showText: '',
      maxHeight: '',
    };
  },
  watch: {
    text: {
      handler(newVal) {
        this.$nextTick(()=>[
          this.calcHandle(newVal)
        ])
      },
      immediate: true,
    },
  },
  methods: {
    //计算
    calcHandle(text) {
      // console.log(this.max_lines)
      let lh = this.$refs.autoTextClamp.style.lineHeight
      //计算最大高度，超过省略号
      let maxHeight = lh.includes('px') ? this.max_lines * parseInt(lh): (lh * (this.$refs.autoTextClamp.style.fontSize || 14)) * this.max_lines + 1
      this.maxHeight = maxHeight
      this.calcText = text.slice(0, -1)
      this.$nextTick(()=>{
        if(this.$refs.calcBox.clientHeight >= maxHeight){
          this.showSlotNode = true
          this.calcHandle(this.calcText)
        }else{
          //完成计算
          this.showText = this.calcText
        }
      })
     },
    toggle() {
      this.expanded = !this.expanded;
      if(this.expanded){
        this.showText = this.text
      }else{
        this.showText = this.calcText
      }
    },
  },
  mounted() {
    
  },
  template: `
      <div ref="autoTextClamp" class="auto_text_clamp" :style="{lineHeight: line_height, maxHeight: expanded? '': (maxHeight + 'px')}">
          <span ref="calcBox" class="calc_box">
            {{ calcText }}
            <span>...</span>
            <span class="slot-box" style="display: inline-block;margin-left: 20px" ref="slotRef" v-if="showSlotNode">
              <template  v-if="$slots.default">
                <slot @click="toggle" :expanded="expanded"></slot>
              </template>
              <span v-else @click="toggle">
                <span v-show="!expanded">{{$t('展开')}}></span>
                <span v-show="expanded">{{$t('收起')}}<</span>
              </span>
            </span>
          </span>
          <span ref="overEllipsis">{{ showText }}{{(showSlotNode && !expanded)? '...': ''}}</span>
          <span class="slot-box" style="display: inline-block;margin-left: 20px" ref="slotRef" v-if="showSlotNode">
              <template  v-if="$slots.default">
                <slot @click="toggle" :expanded="expanded"></slot>
              </template>
              <span v-else @click="toggle">
                <span v-show="!expanded">{{$t('展开')}}></span>
                <span v-show="expanded">{{$t('收起')}}<</span>
              </span>
            </span>
      </div>
  `,
});